'use client';

import React, { ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Box, Divider, Drawer, DrawerProps, IconButton, Stack, Typography } from '@mui/material';
import { X as XMarkIcon } from '@phosphor-icons/react/dist/ssr/X';

interface Props {
  showCloseButton?: boolean;
  icon?: IconDefinition;
  label?: ReactNode;
  viewMoreLink?: string;
  moreDetails?: ReactNode;
  bgcolor?: string;
  width?: string;
}

export default function DrawerTemplate(props: Props & DrawerProps): React.JSX.Element {
  const { ...rest } = props;
  return (
    <Drawer
      ModalProps={{ BackdropProps: { invisible: true }, sx: { zIndex: 1400, overflow: 'scroll' } }}
      PaperProps={{
        elevation: 24,
        sx: {
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100%',
          width: props.width || '440px',
          height: '100%',
        },
      }}
      anchor="right"
      disableScrollLock
      {...rest}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Stack
          direction="row"
          spacing={3}
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            pt: 2,
          }}
        >
          <Typography variant="h6">{props.title}</Typography>
          <IconButton
            onClick={(e) => {
              props.onClose && props.onClose(e, 'escapeKeyDown');
            }}
          >
            <XMarkIcon />
          </IconButton>
        </Stack>
        <Divider />
      </Box>

      {/* Scrollable Content */}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          px: 3,
          pt: 2,
          pb: 4,
        }}
      >
        {props.children}
      </Box>
    </Drawer>
  );
}
